import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export interface IBase64SessionData {
  base64SessionData: string;
}

export const resubmitFailedSession = (data: IBase64SessionData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_LEARNOSITY_RESUBMIT,
    data,
    {}
  );
};
